import { apiGet } from "../../common/utils/request.utils";
import { AppDispatch } from "../../store";
import { respyCalibrationManagementSlice } from "./respyCalbrationManagementSlice";

const { actions } = respyCalibrationManagementSlice;

export function fetchRespyCalibrations(search: string = "") {
	return async function (dispatch: AppDispatch) {
		dispatch(actions.loading());
		try {
			const response = await apiGet("/respy-calibrations", {
				params: { search },
			});
			const sites = response.data;
			dispatch(actions.success(sites));
		} catch (err) {
			dispatch(actions.error(err));
		}
	};
}
